module.exports = __webpack_public_path__ + "static/media/record.8ac024f2.svg";